var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeTrue2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66397 7.68694V3.86584C8.66397 2.28307 9.94701 1 11.5298 1L15.3509 9.59749V20.1055H4.2506C3.29792 20.1163 2.48286 19.4235 2.34004 18.4815L1.02177 9.88407C0.937649 9.32985 1.10116 8.76667 1.46894 8.34369C1.83677 7.92072 2.37178 7.68057 2.93232 7.68694H8.66397Z",
    stroke: "#333333",
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.351 9.49152H17.9016C19.0207 9.47173 19.9773 10.3987 20.1274 11.5078V18.1948C19.9773 19.304 19.0207 20.1251 17.9016 20.1053H15.351V9.49152Z",
    fill: "#73C7A9",
    stroke: "#333333",
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeTrue2);
export default __webpack_public_path__ + "static/media/like_true2.f8ab57833efc0d77227d1a5f4dfd81bd.svg";
export { ForwardRef as ReactComponent };